var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon-lock"),React.createElement("g",{"id":"icons","stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":1},React.createElement("g",{"id":"icon/lock","fillRule":"nonzero"},React.createElement("path",{"d":"M12,0 C15.2377045,0 17.8775403,2.56625155 17.9958605,5.77510787 L18,6 L18,10 L21,10 L21,24 L3,24 L3,10 L6,10 L6,6 C6,2.687 8.687,0 12,0 Z M12,14 C10.896,14 10,14.896 10,16 C10,16.6821538 10.3450888,17.2773964 10.8661629,17.6378607 L11,17.723 L11,20 L13,20 L13,17.723 C13.596,17.376 14,16.738 14,16 C14,14.896 13.104,14 12,14 Z M12,2 C9.86084848,2 8.1091056,3.68692011 8.00490369,5.80062799 L8,6 L8,10 L16,10 L16,6 C16,3.794 14.205,2 12,2 Z","id":"Shape"})))]);
}

Lock.defaultProps = {"fill":"#000000","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Lock;

Lock.default = Lock;
